import InputFieldBase from './SelectField';

export const SelectField = InputFieldBase;

export default SelectField;
